import { render, staticRenderFns } from "./SecondTarBar.vue?vue&type=template&id=6f7db8c2&scoped=true&"
import script from "./SecondTarBar.vue?vue&type=script&lang=js&"
export * from "./SecondTarBar.vue?vue&type=script&lang=js&"
import style0 from "./SecondTarBar.vue?vue&type=style&index=0&id=6f7db8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7db8c2",
  null
  
)

export default component.exports